import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../components/Hyperlink';
import { numberWithSpaces } from '../../../utils/math';
import styles from './law_firm_header_infos.module.scss';
import { LawFirmContext } from '../LawFirmContext';
import { getFormattedDate } from '../../../utils/date-utils/dateUtils';

type Props = {
  nbLawyers: number;
};

export const LawFirmHeaderInfos: FC<Props> = ({ nbLawyers }) => {
  const {
    lawFirmInfos: { ville, adresse, dateCreation },
  } = useContext(LawFirmContext);
  const mapLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    adresse,
  )}`;

  return (
    <div className={styles.container}>
      {!!ville && (
        <InfosItem
          label={
            <FormattedMessage id="law-firm/page/header/LawFirmHeaderInfos.tsx/2" />
          }
          value={ville}
        />
      )}

      {!!adresse && (
        <div className={styles.item}>
          <span className={styles.label}>
            <FormattedMessage id="law-firm/page/header/LawFirmHeaderInfos.tsx/1" />
          </span>
          <Hyperlink className={styles.link} href={mapLink}>
            {adresse}
          </Hyperlink>
        </div>
      )}

      {!!dateCreation && (
        <InfosItem
          label={
            <FormattedMessage id="law-firm/page/header/LawFirmHeaderInfos.tsx/3" />
          }
          value={getFormattedDate(dateCreation)}
        />
      )}

      {nbLawyers > 0 && (
        <InfosItem
          label={
            <FormattedMessage id="law-firm/page/header/LawFirmHeaderInfos.tsx/4" />
          }
          value={
            <FormattedMessage
              id="law-firm/page/header/LawFirmHeaderInfos.tsx/5"
              values={{
                count: nbLawyers,
                countFormatted: numberWithSpaces(nbLawyers),
              }}
            />
          }
        />
      )}
    </div>
  );
};

const InfosItem: FC<{ label: JSX.Element; value: string | JSX.Element }> = ({
  label,
  value,
}) => (
  <div className={styles.item}>
    <span className={styles.label}>{label}</span>
    <span className={styles.value}>{value}</span>
  </div>
);
